import { render, staticRenderFns } from "./LayoutFull.vue?vue&type=template&id=8cdfd452&"
import script from "./LayoutFull.vue?vue&type=script&lang=js&"
export * from "./LayoutFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports